import { formatDate } from '@/logics/date/date';
import { PerformanceRecord } from '@/types/performanceRecord';

export const isPreviousMonthRecordExist = (performanceRecords: PerformanceRecord[]): boolean => {
  const targetDate = new Date();
  targetDate.setMonth(targetDate.getMonth() - 1);
  targetDate.setDate(1);
  const previousMonthStr = formatDate(targetDate);

  const recordExists = performanceRecords.some((record) => {
    return record.target_date === previousMonthStr;
  });

  return recordExists;
};

export const displayPerformanceRecordStatus = (status: string): string => {
  switch (status) {
    case 'draft':
      return '公開待ち';
    case 'published':
      return '公開済み';
    case 'approved':
      return '承認済み';
    case 'rejected':
      return '差し戻し';
    default:
      return '';
  }
};

export const canPublishRecord = (status: string): boolean => {
  return status === 'draft' || status === 'rejected';
};
